import styled from "styled-components"
import theme from "../../config/theme"

export const ReadingProgressBar = styled.div`
  width: ${props => props.readingProgress}%;
  position: absolute;
  height: 5px;
  top: 0;
  background-color: ${theme.colors.mediumPurple};
`